import { useIsStudioNewUi } from '@wix/package-picker-shared-studio';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import classNames from 'classnames';
import React from 'react';
import styles from './FeaturesGrid.scss';
import { FeaturesGridFeatureRowValue } from './FeaturesGridFeatureRowValue';

interface FeaturesGridFeatureRowCellProps {
  productId: string;
  feature: CreativeOffer.GridFeature;
  isRecommended: boolean;
}

export const FeaturesGridFeatureRowCell = ({
  productId,
  feature,
  isRecommended,
}: FeaturesGridFeatureRowCellProps) => {
  const isStudioNewUi = useIsStudioNewUi();

  return (
    <PlatformFeaturesGrid.Content.FeatureRow.Cell
      className={
        isStudioNewUi
          ? classNames(styles.featureRowCell, {
              [styles.recommendedCell]: isRecommended,
            })
          : undefined
      }
    >
      <FeaturesGridFeatureRowValue
        comparisonValue={feature.values?.[productId]}
      />
    </PlatformFeaturesGrid.Content.FeatureRow.Cell>
  );
};
